export default __webpack_public_path__ + "static/media/cp_geo_ml.26e44660.svg";